import clsx from "clsx";
import * as React from "react";

interface ChipProps extends React.ComponentPropsWithoutRef<"div"> {
  active?: boolean;
  withCloseIcon?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  classNames?: {
    root?: string;
    closeButton?: string;
    closeIcon?: string;
  };
  onClose?: (active?: boolean, e?: React.MouseEvent<HTMLButtonElement>) => void;
}

const Chip = React.forwardRef<HTMLSpanElement, ChipProps>((props, ref) => {
  const {
    active = false,
    children,
    withCloseIcon,
    onClose,
    size = "sm",
    className,
    classNames,
    ...rest
  } = props;

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onClose?.(active, e);
    },
    [active, onClose],
  );
  return (
    <span
      data-active={Boolean(active)}
      data-component="chip"
      data-size={size}
      className={clsx(
        "ox-reset ox-ChipsItem",
        size === "xs"
          ? "ox-fz-2xs"
          : size === "sm"
            ? "ox-fz-sm"
            : size === "md"
              ? "oz-fz-md"
              : size === "lg"
                ? "ox-fz-lg"
                : "",
        className,
        classNames?.root,
      )}
      {...rest}
      ref={ref}
    >
      <span>{children}</span>
      {withCloseIcon ? (
        <button
          className={clsx("ox-reset ox-ChipsItemIcon", classNames?.closeButton)}
          onClick={handleClick}
          tabIndex={-1}
          aria-hidden
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={clsx("ox-reset ox-ChipCloseIcon", classNames?.closeIcon)}
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
          </svg>
        </button>
      ) : null}
    </span>
  );
});

Chip.displayName = "Chip";
export { Chip };
export type { ChipProps };
